<template>
  <div class="view-content">
    <div class="content-title">
      <div>
      {{ title }}
    </div>
  <div v-if="jumpText"><a :href="jumpUrl">{{ jumpText }}</a></div>
</div>
    <div class="content-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    jumpText: {
      type: String,
      default: '',
    },
    jumpUrl: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
.content-title{
  display: flex;
  a{
    color: blue;
    padding-left: 30px;
    font-size: 20px;
    font-weight: normal;
  }

}
</style>
